import React from "react";
import { RefreshCw } from "lucide-react";
import useVersionCheck from "../hooks/useVersionCheck";

// Fixed bottom banner shown when a newer published build is detected.
export default function UpdateBanner() {
  const updateAvailable = useVersionCheck();
  if (!updateAvailable) return null;

  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-3 px-4 py-2.5 rounded-full bg-slate-900 text-white shadow-2xl border border-amber-400/40 animate-in fade-in slide-in-from-bottom-4"
      data-testid="update-available-banner"
    >
      <span className="text-sm font-medium">A new version is available.</span>
      <button
        onClick={() => window.location.reload()}
        className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-amber-500 hover:bg-amber-400 text-slate-950 text-sm font-bold transition-colors"
        data-testid="update-refresh-button"
      >
        <RefreshCw className="w-4 h-4" />
        Refresh
      </button>
    </div>
  );
}
